import { ChangeDetectionStrategy, Component, input} from '@angular/core';
import { AbstractFormComponent, FieldTextComponent } from '@spike/scaffolds';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-isin-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonModule, FormsModule, FieldTextComponent],
  templateUrl: './isin-form.html'
})

export class IsinFormComponent extends AbstractFormComponent{
  isCompact = input<boolean>(true);

}
  

